import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from '../RootStore';
import {
  IDashboardStats,
  IDashboardRecordCount,
  IMonthlyRecordCount,
  IUserMonthlyRecordCount,
} from '../../models/dashboard/dashboardModel';
import { dashboardService } from '../../services/dashboard/dashboard.service';

export class DashboardStore {
  rootStore: RootStore;

  // State
  totalHospitals: number = 0;
  totalRecords: number = 0;
  hospitalDistribution: IDashboardRecordCount[] = [];
  monthlyStats: IMonthlyRecordCount[] = [];
  userMonthlyStats: IUserMonthlyRecordCount[] = [];
  error: string | null = null;
  loading: boolean = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setLoading = (loading: boolean) => {
    this.loading = loading;
  };

  setError = (error: string | null) => {
    this.error = error;
  };

  // Ana dashboard verilerini çek
  fetchDashboardStats = async () => {
    try {
      this.setLoading(true);
      const response: any = await dashboardService.getDashboardStats();

      runInAction(() => {
        if (!response.error && response.value) {
          this.totalHospitals = response.value.totalHospitals;
          this.totalRecords = response.value.totalRecords;
          this.hospitalDistribution = response.value.hospitalRecordCounts;
          this.monthlyStats = response.value.monthlyRecordCounts;
        } else {
          this.setError(response.message || 'Dashboard verileri alınamadı');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.setError(error instanceof Error ? error.message : 'Bir hata oluştu');
      });
    } finally {
      runInAction(() => {
        this.setLoading(false);
      });
    }
  };

  // Son 6 ay kullanıcı bazlı istatistikler (backend 6 ay döner)
  fetchUserMonthlyStats = async () => {
    try {
      this.setLoading(true);
      const response: any = await dashboardService.getUserMonthlyRecordStats();
      runInAction(() => {
        if (!response.error && response.value) {
          this.userMonthlyStats = response.value;
        } else {
          this.setError(response.message || 'Kullanıcı bazlı istatistikler alınamadı');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.setError(error instanceof Error ? error.message : 'Bir hata oluştu');
      });
    } finally {
      runInAction(() => {
        this.setLoading(false);
      });
    }
  };

  reset = () => {
    this.totalHospitals = 0;
    this.totalRecords = 0;
    this.hospitalDistribution = [];
    this.monthlyStats = [];
    this.userMonthlyStats = [];
    this.error = null;
    this.loading = false;
  };
}
